/**
 * An object which represents a notification delivered by a push notification system.
 *
 * On Android under `remoteMessage` field a JS version of the Firebase `RemoteMessage` may be accessed.
 * On iOS under `payload` you may find full contents of [`UNNotificationContent`'s](https://developer.apple.com/documentation/usernotifications/unnotificationcontent?language=objc) [`userInfo`](https://developer.apple.com/documentation/usernotifications/unnotificationcontent/1649869-userinfo?language=objc), for example [remote notification payload](https://developer.apple.com/library/archive/documentation/NetworkingInternet/Conceptual/RemoteNotificationsPG/CreatingtheNotificationPayload.html).
 */ /**
 * Schedulable trigger inputs (that are not a plain date value or time value)
 * must have the "type" property set to one of these values.
 */ export var SchedulableTriggerInputTypes = /*#__PURE__*/ function(SchedulableTriggerInputTypes) {
    SchedulableTriggerInputTypes["CALENDAR"] = "calendar";
    SchedulableTriggerInputTypes["DAILY"] = "daily";
    SchedulableTriggerInputTypes["WEEKLY"] = "weekly";
    SchedulableTriggerInputTypes["MONTHLY"] = "monthly";
    SchedulableTriggerInputTypes["YEARLY"] = "yearly";
    SchedulableTriggerInputTypes["DATE"] = "date";
    SchedulableTriggerInputTypes["TIME_INTERVAL"] = "timeInterval";
    return SchedulableTriggerInputTypes;
}({});
/**
 * An enum corresponding to values appropriate for Android's [`Notification#priority`](https://developer.android.com/reference/android/app/Notification#priority) field.
 * @platform android
 */ export var AndroidNotificationPriority = /*#__PURE__*/ function(AndroidNotificationPriority) {
    AndroidNotificationPriority["MIN"] = "min";
    AndroidNotificationPriority["LOW"] = "low";
    AndroidNotificationPriority["DEFAULT"] = "default";
    AndroidNotificationPriority["HIGH"] = "high";
    AndroidNotificationPriority["MAX"] = "max";
    return AndroidNotificationPriority;
}({});
export { PermissionStatus } from 'expo';

//# sourceMappingURL=Notifications.types.js.map
